module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Cargar un Nuevo Comprobante",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('p', [_vm._v("Datos del Documento ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Tipo Documento")])]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Tipo de documento"
    },
    model: {
      value: (_vm.nuevoDocumento.documentType),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentType", $$v)
      },
      expression: "nuevoDocumento.documentType"
    }
  }, _vm._l((_vm.buyOrderDocumentType), function(item) {
    return _c('el-option', {
      key: item.buyOrderDocumentType,
      attrs: {
        "value": item.idBuyOrderDocumentType,
        "label": item.description
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Código AFIP")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('el-select', {
    attrs: {
      "disabled": _vm.nuevoDocumento.documentType === '',
      "required": "",
      "placeholder": "Seleccionar "
    },
    model: {
      value: (_vm.nuevoDocumento.documentCode),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentCode", $$v)
      },
      expression: "nuevoDocumento.documentCode"
    }
  }, _vm._l((_vm.buyOrderDocumentTypeCode), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentTypeCode,
      attrs: {
        "value": item.idBuyOrderDocumentTypeCode,
        "label": item.description
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Letra")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Numero")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("Datos CAE ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Fecha Vencimiento")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Nª")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("PDF (Obligatorio)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    ref: "fileBuyOrder",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6%"
    },
    attrs: {
      "type": "primary",
      "circle": "",
      "icon": "el-icon-upload"
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("Datos de Referencia ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("HES")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("MIGO")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("Importes")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Importe Total")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Importe Impuesto")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Porcentaje Impuesto")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Moneda")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Tipo de Cambio")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveNIC()
      }
    }
  }, [_vm._v("\n            Guardar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])]), _vm._v(" "), _c('h3', [_vm._v(" Panel de control ")]), _vm._v(" "), (_vm.statusList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('th', {
      key: item.idBuyOrderDocumentStatus,
      style: ('text-align: center; vertical-align: middle;width: ' + (100 / _vm.statusList.length) + '%')
    }, [_vm._v(_vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStatus),
      expression: "loadingStatus"
    }],
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('td', {
      key: item.idBuyOrderDocumentStatus,
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item.idBuyOrderDocumentStatus)
        }
      }
    }, [_vm._v(_vm._s(_vm.statusCount[item.idBuyOrderDocumentStatus]))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h3', [_vm._v(" Filtros ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 2
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" OC ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "OC",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        _vm.filters[2].value = _vm.filtroNic
      },
      "blur": function($event) {
        _vm.filters[2].value = _vm.filtroNic
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[2].value = _vm.filtroNic
      }
    },
    model: {
      value: (_vm.filtroNic),
      callback: function($$v) {
        _vm.filtroNic = $$v
      },
      expression: "filtroNic"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" CUIT ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "CUIT",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        _vm.filters[3].value = _vm.filtroCuit
      },
      "blur": function($event) {
        _vm.filters[3].value = _vm.filtroCuit
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[3].value = _vm.filtroCuit
      }
    },
    model: {
      value: (_vm.filtroCuit),
      callback: function($$v) {
        _vm.filtroCuit = $$v
      },
      expression: "filtroCuit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 2
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Estado ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentStatus,
      attrs: {
        "value": item.idBuyOrderDocumentStatus,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Fecha ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "value-format": "yyyy-MM-dd",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(" Resultados ")]), _vm._v(" "), _c('data-tables-server', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBuyOrderDocuments),
      expression: "loadingBuyOrderDocuments"
    }],
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.buyOrderDocuments,
      "total": _vm.totalDocuments,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    },
    on: {
      "query-change": _vm.getBuyOrderDocuments
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "OC"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.nic ? scope.row.nic : '-') + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "CUIT"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.cuit) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Enviada"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.date) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getStatusName(scope.row.idBuyOrderDocumentStatus)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), (_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Info. Rechazo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.mensajeRechazo.length),
            expression: "scope.row.mensajeRechazo.length"
          }],
          attrs: {
            "icon": "el-icon-info",
            "type": "primary",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.mostrarMensajeCompleto(scope.row.mensajeRechazo)
            }
          }
        })]
      }
    }], null, false, 4043462319)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pdf !== '0') ? _c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Acciones"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ver operación",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idBuyOrderDocument)
            }
          }
        })], 1), _vm._v(" "), ((!_vm.user.isProvider && scope.row.idBuyOrderDocumentStatus === '2') || scope.row.idBuyOrderDocumentStatus === '4') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Orden de Pago",
            "placement": "top"
          }
        }, [((scope.row.documentType === '1' || scope.row.documentType === '3')) ? _c('el-button', {
          attrs: {
            "type": scope.row.idBuyOrderDocumentStatus === '2' ? 'primary' : 'success',
            "icon": "far fa-file-alt",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.openModalPaymentOrder(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (scope.row.idBuyOrderDocumentStatus === '3') ? _c('el-button', {
          attrs: {
            "icon": "el-icon-info",
            "type": "primary",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.mostrarMensajeCompleto(scope.row.documentComment)
            }
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Guardar",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.idBuyOrderDocumentStatus === '1') ? [_c('el-button-group', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aprobar",
            "placement": "bottom-end"
          }
        }, [_c('el-button', {
          attrs: {
            "icon": "el-icon-success",
            "size": "big",
            "type": (_vm.documentosAceptados.includes(scope.row)) ? 'primary' : ''
          },
          on: {
            "click": function($event) {
              _vm.showModalAprobar = true
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Rechazar",
            "placement": "bottom-end"
          }
        }, [_c('el-button', {
          attrs: {
            "icon": "el-icon-error",
            "size": "big",
            "type": (_vm.documentosRechazados.includes(scope.row)) ? 'primary' : ''
          },
          on: {
            "click": function($event) {
              _vm.showModalRechazar = true
            }
          }
        })], 1)], 1)] : undefined
      }
    }], null, true)
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("\n              Administrar Facturas\n          ")])], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showModalAprobar,
      "title": "Confirmar acción",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalAprobar = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" ¿Está seguro que desea aprobar esta factura? ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2rem",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModalAprobar = false
      }
    }
  }, [_vm._v("\n                Confirmar\n              ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function () { return _vm.showModalAprobar = false; }
    }
  }, [_vm._v("\n                Cancelar\n              ")])], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showModalRechazar,
      "title": "Confirmar acción",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalRechazar = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" Seleccione el motivo por el que desea rechazar la factura ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Motivo de rechazo"
    },
    model: {
      value: (_vm.nuevoDocumento.mensajeRechazo),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "mensajeRechazo", $$v)
      },
      expression: "nuevoDocumento.mensajeRechazo"
    }
  }, _vm._l((_vm.rejectReasons), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2rem",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModalRechazar = false
      }
    }
  }, [_vm._v("\n                Confirmar\n              ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function () { return _vm.showModalRechazar = false; }
    }
  }, [_vm._v("\n                Cancelar\n              ")])], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": "Confirmar cambios",
      "visible": _vm.showModalConfirmarDocumentacion,
      "max-width": "700px",
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalConfirmarDocumentacion = $event
      },
      "close": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": 'Documentos aceptados (' + _vm.documentosAceptados.length + ')'
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.documentosAceptados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": 'Documentos rechazados (' + _vm.documentosRechazados.length + ')'
    }
  }, [_c('el-table', {
    staticStyle: {
      "max-height": "calc("
    },
    attrs: {
      "data": _vm.documentosRechazados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mensaje",
      "span": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "Seleccione un motivo"
          },
          model: {
            value: (scope.row.mensajeRechazo),
            callback: function($$v) {
              _vm.$set(scope.row, "mensajeRechazo", $$v)
            },
            expression: "scope.row.mensajeRechazo"
          }
        }, _vm._l((_vm.rejectReasons), function(reason) {
          return _c('el-option', {
            key: reason.value,
            attrs: {
              "label": reason.value,
              "value": reason.value
            }
          })
        }), 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirmarDocumentos()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")])])], 1), _vm._v(" "), (_vm.buyOrderDocument) ? _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": 'Orden de pago',
      "visible": _vm.showModalPaymentOrder,
      "width": "70%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalPaymentOrder = $event
      },
      "close": function($event) {
        return _vm.resetNewPaymentOrder()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Orden de Pago / Retenciones")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.buyOrderDocument.paymentOrder && _vm.buyOrderDocument.paymentOrder.pdf) ? _c('td', [(_vm.buyOrderDocument.paymentOrder.pdf === '0') ? _c('span', [_vm._v("No se cargo un archivo")]) : _vm._e(), _vm._v(" "), (_vm.buyOrderDocument.paymentOrder.pdf !== '0') ? _c('a', {
    attrs: {
      "href": _vm.buyOrderDocument.paymentOrder.pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v("  Ver")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && (!_vm.buyOrderDocument.paymentOrder || !_vm.buyOrderDocument.paymentOrder.pdf)) ? _c('span', [_c('input', {
    ref: "filePayment",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Información de Pago")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('td', [(_vm.buyOrderDocument.idBuyOrderDocumentStatus === '4' && _vm.buyOrderDocument.paymentOrder) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buyOrderDocument.paymentOrder.comment)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.buyOrderDocument.idBuyOrderDocumentStatus === '2' && !_vm.user.isProvider && !_vm.buyOrderDocument.paymentOrder) ? _c('span', [_c('vue-editor', {
    model: {
      value: (_vm.newPaymentOrder.comment),
      callback: function($$v) {
        _vm.$set(_vm.newPaymentOrder, "comment", $$v)
      },
      expression: "newPaymentOrder.comment"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.uploadPayment()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Aceptar\n                  ")]) : _vm._e()])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01a9763f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/BillsManagement.vue
// module id = 608
// module chunks = 1